import { ɵɵdefineInjectable, Injectable, Component, ɵɵinject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { finalize, tap } from 'rxjs/operators';
import { AngularSvgIconModule } from 'angular-svg-icon';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'angular-svg-icon';
import * as ɵngcc2 from '@angular/router';

const _c0 = function () { return { "width.px": 100 }; };
class UoaErrorsConfig {
    constructor() {
        this.clientErrorCodes = [400, 401, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414, 415, 418, 429, 431];
        this.serverErrorCodes = [500, 501, 502, 503, 504, 505, 506];
        this.showErrorAsToast = false;
        this.returnUrl = '/';
        this.returnButtonText = 'Reload page';
        this.ErrorPageContent = {
            ErrorCode400: {
                title: `Bad Request`,
                content: `<p>Sorry, something went wrong trying to access that page. Try reloading the page, or going back and following the link again.</p>`,
            },
            ErrorCode401: {
                title: `Not Authorised`,
                content: `<p>Sorry, you do not have permission to access this page.</p>`,
            },
            ErrorCode403: {
                title: `Access Restricted`,
                content: `<p>Sorry, You do not have permission to view this page. Please ensure that you are logged in and try again.</p>
      <p>
        If you still do not have access and believe you are seeing this page in error, contact us on
        <a href="tel:0800 61 62 63" target="_blank">0800 61 62 63 (within New Zealand)</a> or
        <a href="tel:+64 9 373 7513" target="_blank">+64 9 373 7513 (outside New Zealand)</a> or at
        <a href="mailto:studentinfo@auckland.ac.nz" target="_blank">studentinfo@auckland.ac.nz</a>.
      </p>`,
            },
            ErrorCode404: {
                title: `Page Not Found`,
                content: `<p>Sorry, we could not find that page. Check that the URL is correct, or try going back and following the link again.</p>`,
            },
            ErrorCode405: {
                title: `Method not allowed`,
                content: `<p>The requested method is not allowed for the requested URL.</p>
      <p>You may need to login again,
      or try going back and following the link again.</p>
      <p><a href=https://www.auckland.ac.nz/en/about-us/connect-with-us/contact-us.html>
      Please contact us if you need help or would like to report this issue.</a>
      </p>`,
            },
            ErrorCode406: {
                title: `Content Unable to be Displayed`,
                content: `<p>Sorry, something has gone wrong and we cannot display this page.
      You may need to login again, or try going back and following the link again.</p>
      <p><a href=https://www.auckland.ac.nz/en/about-us/connect-with-us/contact-us.html>
      Please contact us if you need help or would like to report this issue.</a></p>`,
            },
            ErrorCode407: {
                title: `Authentication Required`,
                content: `<p>Sorry, we cannot connect you to the page you are trying to reach because you are not correctly logged in.
      Try reloading the page to login, or going back and following the link again.</p>
      <p><a href=https://www.auckland.ac.nz/en/about-us/connect-with-us/contact-us.html>
      Please contact us if you need help or would like to report this issue.</a></p>`,
            },
            ErrorCode408: {
                title: `Request Timeout`,
                content: `<p>The request took a little longer than expected to respond.</p>
      <p>Please reload the page or try again later.</p>`,
            },
            ErrorCode409: {
                title: `Bad Request`,
                content: `<p>The system is currently unavailable, we apologise for any inconvenience.</p>
      <p>Please try again later.</p>`,
            },
            ErrorCode410: {
                title: `Resource is no longer available`,
                content: `<p>
      Sorry, the requested URL is no longer available and we cannot work out what you are trying to reach.
      <a href=https://www.auckland.ac.nz/en/about-us/connect-with-us/contact-us.html>
      Please contact us if you need help or would like to report this issue.</a>.
      </p>`,
            },
            ErrorCode411: {
                title: `Bad Content-Length`,
                content: `<p>Sorry, something has gone wrong and we cannot connect you to the system. Try going back and following the link again.</p>
      <p><a href=https://www.auckland.ac.nz/en/about-us/connect-with-us/contact-us.html>
      Please contact us if you need help or would like to report this issue.</a>.</p>`,
            },
            ErrorCode412: {
                title: `Precondition Failed`,
                content: `<p>Sorry, something has gone wrong and we cannot connect you to the system. Try going back and following the link again.</p>
      <p><a href=https://www.auckland.ac.nz/en/about-us/connect-with-us/contact-us.html>
      Please contact us if you need help or would like to report this issue.</a></p>`,
            },
            ErrorCode413: {
                title: `File upload too large`,
                content: `<p>The size of the file that was being uploaded is too large. Please reduce the file size and try again.</p>`,
            },
            ErrorCode414: {
                title: `Submitted URI too large`,
                content: `<p>Sorry, something has gone wrong with the URL you are trying to access and we cannot connect you.
      Please check the URL is correct, or try going back and following the link again.</p>
      <p><a href=https://www.auckland.ac.nz/en/about-us/connect-with-us/contact-us.html>
      Please contact us if you need help or would like to report this issue.</a></p>`,
            },
            ErrorCode415: {
                title: `Unsupported media type`,
                content: `<p>Sorry, it looks like you are trying to access a file type that is not supported.</p>
       <p><a href=https://www.auckland.ac.nz/en/about-us/connect-with-us/contact-us.html>
       Please contact us if you need help or would like to report this issue.</a></p>`,
            },
            ErrorCode418: {
                title: `I’m a Teapot`,
                content: `<p>Sorry, it looks like you are using the wrong device. This is not for coffee, it is clearly a teapot.</p>
       <p>If you believe you are seeing this error incorrectly, you are.</p>`,
            },
            ErrorCode429: {
                title: `Too Many Requests`,
                content: `<p>You are seeing this because you have made a large number of requests to our system within a short period of time.
      Please wait a minute or two and then try reloading the page.</p>`,
            },
            ErrorCode431: {
                title: `Request Header Fields Too Long`,
                content: `<p>You may be seeing this error due to cookie settings or the URL is too long. Try clearing your cookies
       and reloading the page; or if you have altered the URL try removing this and navigating again.</p>`,
            },
            ErrorCode500: {
                title: `Service Unavailable`,
                content: `<p>The system is currently unavailable and we apologise for any inconvenience.</p>
      <p>Please try again later.</p>`,
            },
            ErrorCode501: {
                title: `Cannot process request`,
                content: `<p>Sorry, we cannot connect you to the system. Try reloading the page, or going back and following the link again.</p>
      <p><a href=https://www.auckland.ac.nz/en/about-us/connect-with-us/contact-us.html>
      Please contact us if you need help or would like to report this issue</a>.</p>`,
            },
            ErrorCode502: {
                title: `Connection Error`,
                content: `<p>We cannot connect you to our systems at the moment.</p>
      <p>Please check your internet connection or try again later.</p>`,
            },
            ErrorCode503: {
                title: `Service Unavailable`,
                content: `<p>The system is currently unavailable. We apologise for any inconvenience.</p>
      <p>Please try again later.</p>`,
            },
            ErrorCode504: {
                title: `Request Timeout`,
                content: `<p>The request took a little longer than expected to respond.</p>
      <p>Please refresh the page or try again a little later.</p>`,
            },
            ErrorCode505: {
                title: `Version Not Supported`,
                content: `<p>Sorry, it looks like you are using a browser or connection that is not supported.
      Check your connection settings or use an alternative browser such as Google Chrome, Firefox or Edge.</p>
      <p><a href=https://www.auckland.ac.nz/en/about-us/connect-with-us/contact-us.html>
      Please contact us if you need help or would like to report this issue.</a></p>`,
            },
            ErrorCode506: {
                title: `Variant also negotiates`,
                content: `<p>Sorry, something has gone wrong. We cannot connect you to the system, or you are trying to access something that you do not have permission to access.</p>
      <p>
        <a href=https://www.auckland.ac.nz/en/about-us/connect-with-us/contact-us.html>
        Try reloading the page, or contact us if you need help or would like to report this issue.</a>
      </p>`,
            },
            ErrorCodeDefault: {
                title: `Unexpected Error`,
                content: `<p>
        Sorry, we seem to have encountered an unexpected error. If you require help, please call
        <a href="tel:0800 61 62 63" target="_blank">0800 61 62 63 (within New Zealand)</a> or
        <a href="tel:+64 9 373 7513" target="_blank">+64 9 373 7513 (outside New Zealand)</a> or at
        <a href="mailto:studentinfo@auckland.ac.nz" target="_blank">studentinfo@auckland.ac.nz</a>
      </p>`,
            },
        };
    }
}
UoaErrorsConfig.ɵfac = function UoaErrorsConfig_Factory(t) { return new (t || UoaErrorsConfig)(); };
UoaErrorsConfig.ɵprov = ɵɵdefineInjectable({ factory: function UoaErrorsConfig_Factory() { return new UoaErrorsConfig(); }, token: UoaErrorsConfig, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UoaErrorsConfig, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class BypassErrorService {
    constructor() {
        this._serverErrorbypassList = [];
        this._clientErrorbypassList = [];
    }
    _getObjectInBypassList(list, url) {
        const bypassObject = list.find(bypass => bypass.url === url);
        return bypassObject;
    }
    _removeObjectFromBypassList(list, bypassObject) {
        const anIndex = list.indexOf(bypassObject);
        if (list.length && anIndex !== -1) {
            list.splice(anIndex, 1);
        }
    }
    bypassError(urlString, statusCodes) {
        const clientErrorCodes = statusCodes.filter(code => code.toString().startsWith('4'));
        const serverErrorCodes = statusCodes.filter(code => code.toString().startsWith('5'));
        if (serverErrorCodes) {
            this._addToServerErrorBypassList(urlString, serverErrorCodes);
        }
        if (clientErrorCodes) {
            this._addToClientErrorBypassList(urlString, clientErrorCodes);
        }
    }
    _addToServerErrorBypassList(url, status) {
        this._serverErrorbypassList.push({ url, status });
    }
    getObjectServerErrorBypassList(url) {
        return this._getObjectInBypassList(this._serverErrorbypassList, url);
    }
    removeErrorServerErrorBypassList(bypassObject) {
        this._removeObjectFromBypassList(this._serverErrorbypassList, bypassObject);
        console.debug('this._serverErrorbypassList', this._serverErrorbypassList);
    }
    _addToClientErrorBypassList(url, status) {
        this._clientErrorbypassList.push({ url, status });
    }
    getObjectClientErrorBypassList(url) {
        return this._getObjectInBypassList(this._clientErrorbypassList, url);
    }
    removeObjectClientErrorBypassList(bypassObject) {
        this._removeObjectFromBypassList(this._clientErrorbypassList, bypassObject);
        console.debug('this._clientErrorbypassList', this._clientErrorbypassList);
    }
}
BypassErrorService.ɵfac = function BypassErrorService_Factory(t) { return new (t || BypassErrorService)(); };
BypassErrorService.ɵprov = ɵɵdefineInjectable({ factory: function BypassErrorService_Factory() { return new BypassErrorService(); }, token: BypassErrorService, providedIn: "root" });
BypassErrorService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BypassErrorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ErrorToastService {
}
ErrorToastService.ɵfac = function ErrorToastService_Factory(t) { return new (t || ErrorToastService)(); };
ErrorToastService.ɵprov = ɵɵdefineInjectable({ factory: function ErrorToastService_Factory() { return new ErrorToastService(); }, token: ErrorToastService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ErrorToastService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class HeaderComponent {
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(); };
HeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["app-header"]], decls: 7, vars: 3, consts: [[1, "flex-same-size"], [1, "logo-wrapper"], ["href", "/", "rel", "noopener"], ["src", "https://cdn.jsdelivr.net/npm/@uoa/web-components/dist/assets/logo/no-translation/vertical/uoa-logo.svg", 3, "svgAriaLabel", "svgStyle"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1, "\u00A0");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1)(3, "a", 2);
        ɵngcc0.ɵɵelement(4, "svg-icon", 3);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 0);
        ɵngcc0.ɵɵtext(6, "\u00A0");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("svgAriaLabel", "University of Auckland Logo")("svgStyle", ɵngcc0.ɵɵpureFunction0(2, _c0));
    } }, directives: [ɵngcc1.SvgIconComponent], styles: ["[_nghost-%COMP%]{display:flex;justify-content:space-between;padding:21px 2vw 0;height:60px;background-color:var(--color-light-1,#f2f2f2);width:100vw;margin-bottom:var(--space-5xl,60px)}[_nghost-%COMP%]   .logo-wrapper[_ngcontent-%COMP%]{position:relative;width:24vw;max-width:100px;color:var(--color-primary,#00467f);cursor:pointer}.flex-same-size[_ngcontent-%COMP%]{flex:1 1 0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'app-header',
                template: "<div class=\"flex-same-size\">&nbsp;</div>\n<div class=\"logo-wrapper\">\n  <a href=\"/\" rel=\"noopener\">\n    <svg-icon\n      [svgAriaLabel]=\"'University of Auckland Logo'\"\n      src=\"https://cdn.jsdelivr.net/npm/@uoa/web-components/dist/assets/logo/no-translation/vertical/uoa-logo.svg\"\n      [svgStyle]=\"{ 'width.px': 100 }\"\n    ></svg-icon>\n  </a>\n</div>\n<div class=\"flex-same-size\">&nbsp;</div>\n",
                styles: [":host{display:flex;justify-content:space-between;padding:21px 2vw 0;height:60px;background-color:var(--color-light-1,#f2f2f2);width:100vw;margin-bottom:var(--space-5xl,60px)}:host .logo-wrapper{position:relative;width:24vw;max-width:100px;color:var(--color-primary,#00467f);cursor:pointer}.flex-same-size{flex:1 1 0}"]
            }]
    }], null, null); })();

class FooterComponent {
}
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(); };
FooterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FooterComponent, selectors: [["app-footer"]], decls: 9, vars: 0, consts: [[1, "footer", "background-dark-3"], ["target", "_blank", "rel", "noopener", "href", "https://www.auckland.ac.nz/en/copyright.html", 1, "padding-left-m", "padding-right-m"], ["target", "_blank", "rel", "noopener", "href", "https://www.auckland.ac.nz/en/privacy.html", 1, "border-left-light-2", "padding-left-m", "padding-right-m"], ["target", "_blank", "rel", "noopener", "href", "https://www.auckland.ac.nz/en/disclaimer.html", 1, "border-left-light-2", "padding-left-m", "padding-right-m"], ["target", "_blank", "rel", "noopener", "href", "https://uoa.custhelp.com/", 1, "border-left-light-2", "padding-left-m", "padding-right-m"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "a", 1);
        ɵngcc0.ɵɵtext(2, " Copyright ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "a", 2);
        ɵngcc0.ɵɵtext(4, " Privacy ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "a", 3);
        ɵngcc0.ɵɵtext(6, " Disclaimer ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "a", 4);
        ɵngcc0.ɵɵtext(8, " Ask Auckland ");
        ɵngcc0.ɵɵelementEnd()();
    } }, styles: [".footer[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;position:absolute;width:100%;bottom:0;padding:var(--space-s,9px)}.background-dark-3[_ngcontent-%COMP%]{background-color:var(--footer-background,var(--color-dark-3,#333))}.footer[_ngcontent-%COMP%], .footer[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--color-light,#fff);text-decoration:none}.padding-left-m[_ngcontent-%COMP%]{padding-left:var(--space-m,12px)}.padding-right-m[_ngcontent-%COMP%]{padding-right:var(--space-m,12px)}.border-left-light-2[_ngcontent-%COMP%]{border-left:1px solid var(--color-light-2,#bec3c4)}@media (max-width:576px){.footer[_ngcontent-%COMP%]{font-size:.667rem}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'app-footer',
                template: "<div class=\"footer background-dark-3\">\n  <a target=\"_blank\" class=\"padding-left-m padding-right-m\" rel=\"noopener\" href=\"https://www.auckland.ac.nz/en/copyright.html\">\n    Copyright\n  </a>\n  <a\n    class=\"border-left-light-2 padding-left-m padding-right-m\"\n    target=\"_blank\"\n    rel=\"noopener\"\n    href=\"https://www.auckland.ac.nz/en/privacy.html\"\n  >\n    Privacy\n  </a>\n  <a\n    class=\"border-left-light-2 padding-left-m padding-right-m\"\n    target=\"_blank\"\n    rel=\"noopener\"\n    href=\"https://www.auckland.ac.nz/en/disclaimer.html\"\n  >\n    Disclaimer\n  </a>\n  <a class=\"border-left-light-2 padding-left-m padding-right-m\" target=\"_blank\" rel=\"noopener\" href=\"https://uoa.custhelp.com/\">\n    Ask Auckland\n  </a>\n</div>\n",
                styles: [".footer{display:flex;justify-content:center;align-items:center;position:absolute;width:100%;bottom:0;padding:var(--space-s,9px)}.background-dark-3{background-color:var(--footer-background,var(--color-dark-3,#333))}.footer,.footer a{color:var(--color-light,#fff);text-decoration:none}.padding-left-m{padding-left:var(--space-m,12px)}.padding-right-m{padding-right:var(--space-m,12px)}.border-left-light-2{border-left:1px solid var(--color-light-2,#bec3c4)}@media (max-width:576px){.footer{font-size:.667rem}}"]
            }]
    }], null, null); })();

class ErrorPage {
    constructor(_route, _errorConfigService) {
        this._route = _route;
        this._errorConfigService = _errorConfigService;
        this._errorCodes = [...this._errorConfigService.clientErrorCodes, ...this._errorConfigService.serverErrorCodes];
        this.errorCode = 'ErrorCodeDefault';
        const httpCode = +this._route.snapshot.paramMap.get('errorCode');
        if (this._errorCodes.includes(httpCode)) {
            this.errorCode = 'ErrorCode' + httpCode;
        }
        this.errorObject = this._errorConfigService.ErrorPageContent[this.errorCode];
        this.returnUrl = this._errorConfigService.returnUrl;
        this.returnButtonText = this._errorConfigService.returnButtonText;
    }
}
ErrorPage.ɵfac = function ErrorPage_Factory(t) { return new (t || ErrorPage)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(UoaErrorsConfig)); };
ErrorPage.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ErrorPage, selectors: [["lib-error"]], decls: 12, vars: 4, consts: [[1, "content-wrapper"], [1, "inner-content"], [1, "padding-top-2xl"], [1, "font-xxl"], [1, "padding-top-2xl", 3, "innerHtml"], [1, "button", "flex"], [1, "flex", 3, "href"]], template: function ErrorPage_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "app-header");
        ɵngcc0.ɵɵelementStart(2, "div", 1)(3, "div")(4, "div", 2)(5, "h1", 3);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(7, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 5)(9, "a", 6);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelement(11, "app-footer");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ctx.errorObject.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHtml", ctx.errorObject.content, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("href", ctx.returnUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.returnButtonText);
    } }, directives: [HeaderComponent, FooterComponent], styles: [".content-wrapper[_ngcontent-%COMP%]{position:relative;width:100%;height:auto;min-height:100vh}.inner-content[_ngcontent-%COMP%]{margin:0 auto;max-width:800px;padding:0 var(--space-m,12px) var(--space-4xl,48px) var(--space-m,12px)}.padding-top-2xl[_ngcontent-%COMP%]{padding-top:var(--space-2xl,21px)}.font-xxl[_ngcontent-%COMP%]{font-size:2rem!important}.flex[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}.button[_ngcontent-%COMP%]{margin-top:var(--space-2xl,21px)}.button[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{min-width:250px;font-weight:700;font-size:1rem;border-radius:var(--space-2xl,21px);height:36px;background:var(--background,var(--color-primary,#00467f));color:var(--color,var(--color-light,#fff));border:none;cursor:pointer;text-decoration:none}.button[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{opacity:.9}"] });
ErrorPage.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: UoaErrorsConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ErrorPage, [{
        type: Component,
        args: [{
                selector: 'lib-error',
                template: "<div class=\"content-wrapper\">\n  <app-header></app-header>\n  <div class=\"inner-content\">\n    <div>\n      <div class=\"padding-top-2xl\">\n        <h1 class=\"font-xxl\">{{errorObject.title}}</h1>\n        <div class=\"padding-top-2xl\" [innerHtml]=\"errorObject.content\"></div>\n      </div>\n      <div class=\"button flex\">\n        <a class=\"flex\" [href]=\"returnUrl\">{{returnButtonText}}</a>\n      </div>\n    </div>\n  </div>\n  <app-footer></app-footer>\n</div>\n",
                styles: [".content-wrapper{position:relative;width:100%;height:auto;min-height:100vh}.inner-content{margin:0 auto;max-width:800px;padding:0 var(--space-m,12px) var(--space-4xl,48px) var(--space-m,12px)}.padding-top-2xl{padding-top:var(--space-2xl,21px)}.font-xxl{font-size:2rem!important}.flex{display:flex;justify-content:center;align-items:center}.button{margin-top:var(--space-2xl,21px)}.button a{min-width:250px;font-weight:700;font-size:1rem;border-radius:var(--space-2xl,21px);height:36px;background:var(--background,var(--color-primary,#00467f));color:var(--color,var(--color-light,#fff));border:none;cursor:pointer;text-decoration:none}.button a:hover{opacity:.9}"]
            }]
    }], function () { return [{ type: ɵngcc2.ActivatedRoute }, { type: UoaErrorsConfig }]; }, null); })();

class ClientErrorInterceptor {
    constructor(_router, _errorConfigService, _bypassService, _toastService) {
        this._router = _router;
        this._errorConfigService = _errorConfigService;
        this._bypassService = _bypassService;
        this._toastService = _toastService;
        this._ERROR_CODES = this._errorConfigService.clientErrorCodes;
    }
    intercept(req, next) {
        const bypassObject = this._bypassService.getObjectClientErrorBypassList(req.url);
        console.debug('bypassObject in client error list: ', bypassObject);
        return next.handle(req).pipe(finalize(() => this._bypassService.removeObjectClientErrorBypassList(bypassObject)), tap((res) => { }, (error) => {
            if (this._ERROR_CODES.includes(error.status) && !(bypassObject && bypassObject.status.includes(error.status))) {
                console.warn(`ClientErrorInterceptor - HTTP ${error.status}`);
                if (this._errorConfigService.showErrorAsToast) {
                    this._toastService.createToast(this._errorConfigService.ErrorPageContent['ErrorCode' + error.status]);
                }
                else {
                    this._errorConfigService.returnUrl = this._router.url;
                    return this._router.navigate(['/error', error.status]);
                }
            }
        }));
    }
}
ClientErrorInterceptor.ɵfac = function ClientErrorInterceptor_Factory(t) { return new (t || ClientErrorInterceptor)(ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(UoaErrorsConfig), ɵngcc0.ɵɵinject(BypassErrorService), ɵngcc0.ɵɵinject(ErrorToastService)); };
ClientErrorInterceptor.ɵprov = ɵɵdefineInjectable({ factory: function ClientErrorInterceptor_Factory() { return new ClientErrorInterceptor(ɵɵinject(Router), ɵɵinject(UoaErrorsConfig), ɵɵinject(BypassErrorService), ɵɵinject(ErrorToastService)); }, token: ClientErrorInterceptor, providedIn: "root" });
ClientErrorInterceptor.ctorParameters = () => [
    { type: Router },
    { type: UoaErrorsConfig },
    { type: BypassErrorService },
    { type: ErrorToastService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ClientErrorInterceptor, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.Router }, { type: UoaErrorsConfig }, { type: BypassErrorService }, { type: ErrorToastService }]; }, null); })();

class ServerErrorInterceptor {
    constructor(_router, _errorConfigService, _bypassService, _toastService) {
        this._router = _router;
        this._errorConfigService = _errorConfigService;
        this._bypassService = _bypassService;
        this._toastService = _toastService;
        this._ERROR_CODES = this._errorConfigService.serverErrorCodes;
    }
    intercept(req, next) {
        const bypassObject = this._bypassService.getObjectServerErrorBypassList(req.url);
        console.debug('bypassObject in server errors list: ', bypassObject);
        return next.handle(req).pipe(finalize(() => this._bypassService.removeObjectClientErrorBypassList(bypassObject)), tap((res) => { }, (error) => {
            if (this._ERROR_CODES.includes(error.status) && !(bypassObject && bypassObject.status.includes(error.status))) {
                console.warn(`ServerErrorInterceptor - HTTP ${error.status}`);
                if (this._errorConfigService.showErrorAsToast) {
                    this._toastService.createToast(this._errorConfigService.ErrorPageContent['ErrorCode' + error.status]);
                }
                else {
                    this._errorConfigService.returnUrl = this._router.url;
                    return this._router.navigate(['/error', error.status]);
                }
            }
        }));
    }
}
ServerErrorInterceptor.ɵfac = function ServerErrorInterceptor_Factory(t) { return new (t || ServerErrorInterceptor)(ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(UoaErrorsConfig), ɵngcc0.ɵɵinject(BypassErrorService), ɵngcc0.ɵɵinject(ErrorToastService)); };
ServerErrorInterceptor.ɵprov = ɵɵdefineInjectable({ factory: function ServerErrorInterceptor_Factory() { return new ServerErrorInterceptor(ɵɵinject(Router), ɵɵinject(UoaErrorsConfig), ɵɵinject(BypassErrorService), ɵɵinject(ErrorToastService)); }, token: ServerErrorInterceptor, providedIn: "root" });
ServerErrorInterceptor.ctorParameters = () => [
    { type: Router },
    { type: UoaErrorsConfig },
    { type: BypassErrorService },
    { type: ErrorToastService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServerErrorInterceptor, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.Router }, { type: UoaErrorsConfig }, { type: BypassErrorService }, { type: ErrorToastService }]; }, null); })();

class ErrorPagesModule {
}
ErrorPagesModule.ɵfac = function ErrorPagesModule_Factory(t) { return new (t || ErrorPagesModule)(); };
ErrorPagesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ErrorPagesModule });
ErrorPagesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: HTTP_INTERCEPTORS, multi: true, useClass: ClientErrorInterceptor },
        { provide: HTTP_INTERCEPTORS, multi: true, useClass: ServerErrorInterceptor },
    ], imports: [[CommonModule, AngularSvgIconModule.forRoot()], RouterModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ErrorPagesModule, [{
        type: NgModule,
        args: [{
                declarations: [ErrorPage, HeaderComponent, FooterComponent],
                imports: [CommonModule, AngularSvgIconModule.forRoot()],
                providers: [
                    { provide: HTTP_INTERCEPTORS, multi: true, useClass: ClientErrorInterceptor },
                    { provide: HTTP_INTERCEPTORS, multi: true, useClass: ServerErrorInterceptor },
                ],
                exports: [RouterModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ErrorPagesModule, { declarations: function () { return [ErrorPage, HeaderComponent, FooterComponent]; }, imports: function () { return [CommonModule, ɵngcc1.AngularSvgIconModule]; }, exports: function () { return [RouterModule]; } }); })();

/*
 * Public API Surface of error-pages
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BypassErrorService, ErrorPage, ErrorPagesModule, ErrorToastService, UoaErrorsConfig, HeaderComponent as ɵa, FooterComponent as ɵb, ClientErrorInterceptor as ɵc, ServerErrorInterceptor as ɵd };

